import axios from '@/api/axios'
const  VUE_APP_BASE_API = process.env.VUE_APP_BASE_API
import urls from '@/api/url'
export default{ 
    getUserList: (formData) => 
        axios.post('/api-exam-signup/signup/check/user/list', formData), // 待审核用户列表

    setUserCheck: (formData) => 
        axios.post('/api-exam-signup/signup/check/user/check', formData), // 审核–单个审核成功

    setUserBatchCheck: (formData) => 
        axios.post('/api-exam-signup/signup/check/user/batchCheck', formData), // 审核，多个用户审核成功

    setUserAllCheck: (formData) => 
        axios.post('/api-exam-signup/signup/check/user/allCheck', formData), // 全部审核成功

    setUserNotApprove: (formData) => 
        axios.post('/api-exam-signup/signup/check/user/notApprove', formData), // 审核， 单 个用户不通过 

    orgList: (formData) =>
        axios.post(urls.orgList, formData), // 导出加载考生列表

    exportPhotoStatus: (formData) =>
        axios.post(urls.exportPhotoStatus, formData), // 查血学生导出状态

    exportPhoto: (formData) =>
        axios.post('/api-exam-signup/signup/check/exportPhoto', formData), // 导出考生照片

    examPlanList: (formData) =>
        axios.post('/api-exam-signup/signup/check/examPlan/list', formData), // 获得导出成绩前的计划列表
        
    exportFile: (url, data, method) => axios({
        method: method || 'post',
        url,
        data,
        responseType: 'blob'
    }),

    getKwExamPlan: (formData) =>
        axios.post(`/api-exam-signup/signup/check/kwExamPlan/list`, formData), // 绑定正式或练习计划前获取考务的计划列表

    setExamPlan: (formData) =>
        axios.post(`/api-exam-signup/signup/check/examPlan/set`, formData), // 设置某个计划为正式或者练习计划

    exportData: '/api-exam-signup/signup/check/exportData', // 导出考生审核数据

    exportScore: '/api-exam-signup/signup/check/exportScore', // 导出考生成绩

    uploadCheckAutoCheck: `${VUE_APP_BASE_API}/api-exam-signup/signup/check/autoCheck`, // 上传

}